import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

const SHARED_ACTION_BUTTON_PROPS = {
  size: ButtonSize.SMALL,
  buttonStyle: ButtonStyle.CIRCLE_ICON,
};

export interface DashboardLinkTableActionButtonsProps {
  onEdit?: () => void; // if unspecified, the edit icon will not be rendered.
  onRemove?: () => void; // if unspecified, the remove icon will not be rendered.
}

export default function DashboardLinkTableActionButtons({
  onEdit,
  onRemove,
}: DashboardLinkTableActionButtonsProps): JSX.Element {
  return (
    <div className="u-justify-content-end">
      {onEdit && (
        <Button
          {...SHARED_ACTION_BUTTON_PROPS}
          onClick={() => {
            onEdit();
          }}
          icon="edit"
        />
      )}
      {onRemove && (
        <Button
          {...SHARED_ACTION_BUTTON_PROPS}
          onClick={() => {
            onRemove();
          }}
          icon="delete"
        />
      )}
    </div>
  );
}
